import React from 'react'
import { db } from './firebaseconfig'
import Header1 from './Header'
import "./React-tables.css"
import {useForm} from 'react-hook-form'
import Footer from "./Footer"
import ReactGA from "react-ga"
import MediaQuery, { useMediaQuery } from 'react-responsive'



class EngDisplay extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      Documents: null,
      Query: "",
      docsexist:true,
      noofdocs:0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    ReactGA.initialize("UA-177281473-1", {siteSpeedSampleRate: 100})
  
  }

  handleClick(e) {
    ReactGA.event({
      category:'AD',
      action:"Engineering-AD"
    })

  }
 

  handleChange(event) {
    this.setState({Query: event.target.value});
  }

  handleSubmit(event) {

    const Q1=this.state.Query.replace(/\s+/g, "");
    const Q2=Q1.toUpperCase()
    var i=0;
    db.collection('College of Engineering').where('Subject','==', Q2).get().then((snapshot)=>{
      const docs1 = []
      snapshot.forEach( doc => {
        const data = doc.data()
        docs1.push(data)
        i=i+1;
        this.setState({docsexist: true})
      })
      this.setState({Documents: docs1})
      this.setState({noofdocs: i})
    }).catch(error => console.log(error))
    if (i<1){
      this.setState({docsexist: false})
  }
    event.preventDefault();
  
  }

  render(){
    return(
      <>
      <section id="cta2" className="container">
      <Header1></Header1>
      </section>
      <section className="box special">
      <h2>College of Engineering</h2>
      <form onSubmit={this.handleSubmit}>
       <input type="text" placeholder="Search for a subject" value={this.state.Query} onChange={this.handleChange} />
       <br></br>
       <input type="submit" value="Search" />

         </form>
      </section>
      <br></br>
      <br></br>
        <table>
          <thead>
        <tr>
          <th>Name</th>
          <th>Document Type</th>
          <th>Subject</th>
          
          <th>Download</th>
          
        </tr>
        </thead>
        <tbody>
        {
          
                   this.state.Documents && this.state.Documents.map( document =>{
            var docName2=""
            if(document.Name.length > 10 ){ docName2= document.Name.substring(0,10) + "..."}else{docName2=document.Name}
            return(
             <tr>
             <MediaQuery maxDeviceWidth={450}><td>{docName2} </td></MediaQuery>
             <MediaQuery minDeviceWidth={451}><td>{document.Name} </td></MediaQuery>
             <td> {document.DocumentType}</td>
             <td>{document.Subject}</td>
              
             <td> <a href={document.URLOD} className="button2">Download </a></td>
             </tr>
            
          )
          }
          )
        }
        

        </tbody>
        </table>


        { this.state.docsexist? ( <div></div> ) : (<div><center><h1>No Documents Found</h1></center></div>)}
        { this.state.noofdocs>=1? ( <div><center><a href="/Report" className="button">Report a document </a></center></div> ) : (<div></div>)}
        <br/><br/><br/><br/><br/><br/><br/><br/> <br/><br/><br/><br/><br/>

        
<Footer></Footer>
      </>
    )
  }

}

export default EngDisplay